<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="filaProcedimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Ação
                            <span v-if="laudo && laudo.atendimento_procedimento">
                                #{{ laudo.atendimento_procedimento.id_atendimento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="laudo" class="card">
                            <div class="card-body">
                                <celula-dados-paciente :hor="dados_paciente(laudo)" />

                                <div v-if="laudo.atendimento_procedimento.atendimento.medico_solicitante">
                                    <hr>
                                    Solicitante: {{ laudo.atendimento_procedimento.atendimento.medico_solicitante.st_nome }}
                                    <div v-if="laudo.atendimento_procedimento.atendimento.medico_solicitante.conselho" class="small">
                                        {{ laudo.atendimento_procedimento.atendimento.medico_solicitante.conselho.st_sigla }}
                                        {{ laudo.atendimento_procedimento.atendimento.medico_solicitante.st_numero_conselho }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="laudo && ( $store.state.user.id_usuario == 1 )" class="form-row mb-3">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Urgente"
                                    v-model="laudo.atendimento_procedimento.fl_urgente">
                                    <template v-slot:buttonposcb>
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-outline-success" @click="atualizar_urgente(laudo.atendimento_procedimento)" :disabled="$store.state.loading">
                                                <div class="spinner-border spinner-border-sm" role="status" v-if="$store.state.loading">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                <i class="fa fa-check" aria-hidden="true" v-else></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div v-if="laudo && laudo.fila_block" class="alert alert-danger">
                            <i class="fa-solid fa-triangle-exclamation mr-3"></i>
                            Aguardando: <strong>{{ laudo.fila_block.search }}</strong>
                        </div>

                        <div v-else>

                            <div class="list-group" v-if="fila && laudo">
                                <button type="button" class="list-group-item list-group-item-action" :class="'list-group-item-' + status.st_color"
                                    v-for="(status, isx) in fila.lista_status" :key="isx"
                                    :disabled="$store.state.loading" @click="laudo_status(status)">
                                    {{ status.st_acao }}
                                </button>
                            </div>

                            <button type="button" class="btn btn-outline-primary btn-sm mt-3"
                                v-if="lista && laudo && listar_laudos().length > 2" @click="toggle_selecionados(laudo)">
                                Todos
                            </button>

                            <ul class="list-group mt-3" v-if="lista && laudo">
                                <li class="list-group-item" v-for="(ld, iix) in listar_laudos()" :key="iix">
                                    <input type="checkbox" class="mr-3" v-model="ld.sel"
                                        :disabled="ld.id_laudo == laudo.id_laudo">
                                    <span v-if="ld">
                                        {{ ld.atendimento_procedimento.procedimento.search }}
                                    </span>
                                </li>
                            </ul>

                        </div>

                        <div class="mt-3">
                            <anexar-laudo-externo :laudo_arq="laudo" :pode_alterar="true" @refresh="refresh_arquivos()" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import AnexarLaudoExterno from './AnexarLaudoExterno.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return {
            laudo: null,
            fila: null, 
            lista: null, 
        };
    },

    components: { 
        CelulaDadosPaciente,
        AnexarLaudoExterno, 
        AzInput       
    },

    methods: {
        atualizar_urgente (atp) { 
            this.$util.atualizar(this, { 
                service: "laudos",
                func: 'atualizar_urgente', 
                dados: { 
                    id_atendimento_procedimento: atp.id_atendimento_procedimento, 
                    fl_urgente: atp.fl_urgente, 
                }, 
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        refresh_arquivos () { 

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.laudo.id_laudo,
                    type: 'laudo',
                }
            })
            .then(res => {
                this.laudo.arquivos = res;
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });

        },

        listar_laudos () {

            if ( !this.lista )
                return [];

            return this.lista.filter(item => item.atendimento_procedimento
                && item.atendimento_procedimento.id_atendimento == this.laudo.atendimento_procedimento.id_atendimento
            );

        },

        toggle_selecionados(laudo) {
            let lista = this.listar_laudos();

            let opcao = lista.find(ld => ld.id_laudo != laudo.id_laudo && !ld.sel);

            lista.forEach(ld => {
                if ( ld.id_laudo != laudo.id_laudo ) {
                    ld.sel = opcao;
                }
            })
        },

        laudo_status (status) { 
            let lista_laudos;

            if ( this.fila && this.fila.fl_fila_procedimento ) {
                lista_laudos = this.lista.filter(item => item.atendimento_procedimento
                        && item.atendimento_procedimento.id_atendimento == this.laudo.atendimento_procedimento.id_atendimento
                        && ( item.sel || item.id_laudo == this.laudo.id_laudo )
                    )
                    .map(item => item.id_laudo);
            }

            let id_recepcao = this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null;

            if ( !id_recepcao ) { 
                id_recepcao = _.get(this.laudo, 'atendimento_procedimento.atendimento.marcacao.id_recepcao');
            }

            this.$util.atualizar(this, {
                service: 'laudos',
                func: 'status',
                dados: {
                    id_laudo: this.laudo.id_laudo,
                    id_status_laudo: status.id_status_laudo,
                    local: this.$util.getCookie('local-chamada'),
                    fila: this.fila ? this.fila.id_fila_laudo : null,
                    pos_atend: this.fila ? this.fila.fl_pos_atendimento : null,
                    lista: lista_laudos,
                    id_recepcao: id_recepcao,
                    block_painel: this.$util.getCookie('nao-enviar-painel'),
                },
                toast: true,
                modal: 'filaProcedimentoModal',
                callback: res => {
                    if ( res == 'OK' || res.id_status_laudo ) {
                        this.$emit('refresh');
                    }
                }
            });
        },

        carregar_fila(id_fila_laudo, laudo) { 

            this.$util.loadItem(this, { 
                service: 'laudos',
                func: 'fila_laudo',
                parms: { 
                    id_fila_laudo: id_fila_laudo,
                }
            })
            .then(res => {
                this.fila = res.fila;
                this.abrir(id_fila_laudo, laudo);
            });

        },

        abrir(id_fila_laudo, laudo, lista_laudos = null) { 

            if ( lista_laudos ) { 
                this.lista = lista_laudos;
            }

            if ( !this.fila || ( this.fila.id_fila_laudo != id_fila_laudo ) ) { 
                this.carregar_fila(id_fila_laudo, laudo);
                return; 
            }

            this.laudo = laudo;

            let lista = this.listar_laudos();

            lista.forEach(ld => {
                if ( ld.id_laudo == laudo.id_laudo ) {
                    ld.sel = true;
                } else {
                    ld.sel = ( this.fila.fl_acao_individual ? false : true );
                }
            });

            if ( this.fila.in_ordem_atend ) { 

                this.$util.loadItem(this, { 
                    service: 'laudos',
                    func: 'check_filas',
                    parms: { 
                        id_fila_laudo: this.filtro.id_fila_laudo,
                        id_atendimento: laudo.atendimento_procedimento.id_atendimento,
                    }
                })
                .then(res => {
                    this.laudo.fila_block = res.fila; 
                    this.$forceUpdate(); 
                });

            }

            $('#filaProcedimentoModal').modal('show');
        },

        dados_paciente(laudo) {
            return {
                marcacao: {
                    plano: laudo.atendimento_procedimento.atendimento.plano,
                    paciente: laudo.atendimento_procedimento.atendimento.paciente,
                    fl_preferencial: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.fl_preferencial
                        : false,
                }
            };
        },
    }
}
</script>
